var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.241 0.143066L12 3.9397V22.0607L3.241 25.8574L0 24.0302V1.9702L3.241 0.143066ZM2.77562 1.45607L1.59557 2.12048L2.77562 2.52387V1.45607ZM2.77562 3.48094L0.98892 2.86399V23.1364L2.77562 22.5195V3.48094ZM3.76454 22.1794V3.82106L8.19391 5.34762V20.6528L3.76454 22.1794ZM2.77562 23.4765L1.59557 23.8799L2.77562 24.5443V23.4765ZM3.76454 24.6472V23.1364L8.70083 21.4359L10.1801 21.8709L3.76454 24.6551V24.6472ZM11.0111 21.1748L9.18283 20.637V5.37135L11.0111 4.8414V21.1748ZM10.1801 4.14535L8.70083 4.57247L3.76454 2.8719V1.36115L10.1717 4.13744L10.1801 4.14535Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8e09509a46b50e05d13f6521f5e397a9.svg";
export { ForwardRef as ReactComponent };